import { FormControl } from '@angular/forms'
import { URLSearchParams } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import { Subject } from 'rxjs/Subject'

import { IAppHttp } from 'core/http/i-app-http'

export class RemoteValidator {
  private validatorInput: Subject<string>
  private validatorObservable: Observable<any>

  constructor(
    private http: IAppHttp,
    private url: string,
    private errorKey: string,
    private requestData: Object|Function = {},
    private minValueLength: number = 1,
    private debounceTime: number = 600
  ) {
    this.validate = this.validate.bind(this)

    this.validatorInput = new Subject()
    this.validatorObservable = this.validatorInput
      .debounceTime(this.debounceTime)
      .distinctUntilChanged()
      .switchMap(value => {
        let params = new URLSearchParams()
        let data = (this.requestData instanceof Function) ? this.requestData() : this.requestData
        for(let key in data) {
          params.set(key, data[key])
        }
        params.set('value', value)
        return this.http.get(this.url, { search: params })
          .flatMap((response) => {
            let result = response.json()['valid'] ? null : { [this.errorKey]: true }
            return Observable.of(result)
          })
          .catch(() => Observable.of(null))
      })
      .share()
      .take(1)
  }

  validate(control: FormControl): Promise<any> {
    if(!control.value || control.value.length < this.minValueLength) {
      return null
    } else {
      setTimeout(() => this.validatorInput.next(control.value), 0)
      return this.validatorObservable.toPromise()
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators/remote.validator.ts